export default {
  menu(state) {
    return state.bs_app
  },
  menuBasicInfo(state) {
    return state.menuBasicInfo
  },
  menuDetail(state) {
    return state.menuDetail
  }
}